import { render, staticRenderFns } from "./SchoolMeeting.vue?vue&type=template&id=e4448636&scoped=true&"
import script from "./SchoolMeeting.vue?vue&type=script&lang=js&"
export * from "./SchoolMeeting.vue?vue&type=script&lang=js&"
import style0 from "./SchoolMeeting.vue?vue&type=style&index=0&id=e4448636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4448636",
  null
  
)

export default component.exports